import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentTv } from '../../../Redux/Reducers/tvRemoteReducer';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../../customHook/getCssStyle';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import { getCleanUrl } from '../../../utils/Helper';
import CustomPressable from '../../../components/customPressable/customPressable';
import { CHEVRON_RIGHT } from '../../../assets';

const TVSelect_Landscape = (props) => {
    
    const { loading } = props;
  
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const getStyles = useCssStyle();

    const { currentWidget } = useSelector((state) => state.deviceConfigSlice);
    const { currentTv, roomRemoteDetails } = useSelector(state => state.tvRemoteSlice);

    const onTVSelect = (TVdata) => {
        dispatch(setCurrentTv(TVdata));
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'tvRemoteRootContainer_landscape'])} id='widgetRootContainer tvRemoteRootContainer_landscape'>
            <HeaderWithBack />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'tvRemoteMainContainer_landscape'])} 
                showsVerticalScrollIndicator={false}
                id='widgetmainContainer tvRemoteMainContainer_landscape'
            >

            <View style={getStyles(['widgetmainContainerHeaderContainer', 'tvRemoteHeaderContainer_landscape'])} id='tvRemoteHeaderContainer_landscape'>
                {
                    currentWidget?.widgetHeaderImageUrl && 
                        <ImageComp
                            source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                            style={getStyles(['widgetmainContainerHeaderImg', 'tvRemoteHeaderImg_landscape'])} id={"tvRemoteHeaderImg_landscape"}
                        />
                }
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'tvRemoteHeaderTitleContainer_landscape'])} id='tvRemoteHeaderTitleContainer_landscape'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'tvRemoteHeaderTitle_landscape'])} id='tvRemoteHeaderTitle_landscape'>
                        {currentWidget.displayName}
                    </Text>
                </View>
            </View>

            <View style={getStyles(['widgetmainContainerChildContainer', 'tvRemoteMainContainerChildContainer_landscape'])} id='tvRemoteMainContainerChildContainer_landscape'>
                {roomRemoteDetails?.length ? 
                    <View style={getStyles(["tvChannelsListContainer"])} id='tvChannelsListContainer_landscape'>
                        <Text style={getStyles(["tvRemoteSelectHeadingText"])} id='tvRemoteSelectHeadingText'>{t('room_control.tv_control.tv_select_txt')}</Text>

                        <View style={getStyles(["tvSelectItemListContainer_landscape"])} id='tvSelectItemListContainer_landscape'>
                            {roomRemoteDetails.map((iterator, index) => {
                            return <CustomPressable onPress={() => onTVSelect(iterator)} style={getStyles(["list_itemContainer", "tvSelectListItemContainer"])} id="list_itemContainer tvSelectListItemContainer">
                                    <View style={getStyles(["list_itemContainer_textContainer", "tvSelectItemTextContainer"])} id='list_itemContainer_textContainer tvSelectItemTextContainer'>
                                        <Text style={getStyles(["list_itemContainer_textContainer_title", "tvSelectItemLabel"])} id='list_itemContainer_textContainer_title tvSelectItemLabel'>
                                            {iterator.deviceName !== "null" ? iterator.deviceName : index === 0 ? " TV" : ` TV ${index}`}
                                        </Text>
                                    </View>

                                    <View style={getStyles(['list_itemContainer_arrow', 'activitiesEventList_itemContainer_arrow'])} >
                                        <ImageComp source={CHEVRON_RIGHT} style={getStyles(['list_itemContainer_arrow_img'])}/>
                                    </View>
                                </CustomPressable>
                            })}
                        </View>
                    </View> 
                    
                    : !loading && <View style={getStyles(["tvRemoteNoTvTextContainer_landscape"])} id='tvRemoteNoTvTextContainer_landscape'>
                        <Text style={getStyles(["tvRemoteNoTvText_landscape"])} id='tvRemoteNoTvText_landscape'>{t('room_control.tv_control.no_tv_txt')}</Text>
                    </View>}
            </View>
            </ScrollView>
        </View>
    )
}

export default TVSelect_Landscape
